module.exports = __webpack_public_path__ + "img/Group 112.1c00d2ae.png";